module.exports = __webpack_public_path__ + "img/red-check.fbb18a15.svg";